import React, { type FC, memo, useRef } from 'react';
import { ImageBooster } from '@wix/media-image-booster';
import { HttpClient } from '@wix/http-client';
import { create } from '@wix/fedops-logger';
import { connectMediaImageBoosterPanel } from './mediaImageBoosterPanel.mapper';
import { MEDIA_IMAGE_BOOSTER_ORIGIN } from './mediaImageBoosterPanel.constants';
import type { MediaImageBoosterPanelProps } from './mediaImageBoosterPanel.types';
import { languages } from '#packages/util';

const MediaImageBoosterPanel: FC<MediaImageBoosterPanelProps> = ({
  instanceToken,
  closePanel,
  fileId,
  metaSiteId,
  onSave,
}) => {
  const httpClient = useRef(
    new HttpClient({
      baseURL: 'https://editor.wix.com',
      getAppToken: () => instanceToken,
    }),
  ).current;

  const lang = languages.getLanguageCode();

  return (
    <ImageBooster
      locale={lang}
      fileId={fileId}
      onSave={onSave}
      onClose={closePanel}
      metaSiteId={metaSiteId}
      httpClient={httpClient}
      createFedopsLogger={create}
      biOrigin={MEDIA_IMAGE_BOOSTER_ORIGIN}
      instanceToken={instanceToken}
    />
  );
};

export default connectMediaImageBoosterPanel(memo(MediaImageBoosterPanel));
